
// import ApiClient from "../helpers/apiClient";
// import urls from "../utils/urls";

// const useApiClient = () => {	
// 	const api = new ApiClient();
// 	return {
// 		api,
// 		urls,
// 	};
// };

// export default useApiClient;


import api from "../helpers/apiClient";
import urls from "../utils/urls";

const useApiClient = () => {    
    return {
        api,
        urls,
    };
};

export default useApiClient;